function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.42 1.38a.76.76 0 00-.7-.08c-1.43.57-3.01.57-4.44 0a.76.76 0 00-.7.08c-.21.14-.33.37-.33.62v6c0 .41.34.75.75.75s.75-.34.75-.75V6.02c.58.14 1.16.22 1.75.22.94 0 1.88-.18 2.78-.54.28-.11.47-.39.47-.7V2c0-.25-.12-.48-.33-.62z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 21.25h-1.25V11c0-2.42-1.33-3.75-3.75-3.75H7c-2.42 0-3.75 1.33-3.75 3.75v10.25H2c-.41 0-.75.34-.75.75s.34.75.75.75h20c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zm-2.75-8.5v8.5h-2.51v-8.5h2.51zm-8.01 8.5h-2.5v-8.5h2.5v8.5zm1.5-8.5h2.5v8.5h-2.5v-8.5zm-7.99 0h2.49v8.5H4.75v-8.5z"
})));